module.exports = {
  language: {
    name: "中文"
  },
  //導航欄
  header: {
    home: "Home",
    product: "Product",
    company: "Company Overview",
    contactUs: "Contact Us",
    companyDynamics: "Company Dynamics",
    auxiliaries: "Auxiliaries",
    cuttingFluid: "Metal cutting fluid additives",
    agricultural: "Agricultural chemical additives",
    paint: "Paint and coating additives"
  },
  //首頁
  home: {
    companyName: "Nanjing Shangqin New Material Technology Co., Ltd",
    aboutUs: 'About Us',
    companyProfile1: `Shangqin (Skyline Chemical) is a leading chemical manufacturer in China, recognized as a national high-tech enterprise. It is located in Nanjing, the ancient capital of Six Dynasties.`,
    companyProfile2: `For over a decade, the company has been deeply engaged in the field of specialty chemicals, assembling a professional and highly efficient R&D team. It has established in-depth partnerships with numerous Fortune Global 500 chemical companies and successfully developed nearly 100 chemicals with special structures. With stable quality and innovation capabilities, the company has earned the trust of global customers and high recognition within the industry. Its products are exported to Europe, America, Southeast Asia, and many other regions, serving numerous clients among the world's top 50 chemical companies. In 2025, its production base located in the national-level chemical park—Nanjing Jiangbei New Materials Science and Technology Park—was officially completed and put into operation. The advanced and standardized facilities, along with ample production capacity, provide a solid foundation for large-scale, high-quality deliveries.`,
    companyProfile3: `The company specializes in the R&D, production, and sales of various esterification products, including phosphate esters, TMPTO, specialty reactive monomers, and specialty polymers. These products are widely used in industries such as textile and leather auxiliaries, lubricants and metalworking fluids (MWF), pesticide formulations, paints and coatings, home and industrial cleaning (HI&I), semiconductors, and new energy.Shangqin remains consistently customer-centric, viewing clients as long-term, reliable strategic partners. We not only provide standardized high-quality products but also possess strong capabilities in customized development and solution services. We look forward to working hand in hand with partners from all sectors to create value together and achieve mutual success.`,
    chemicalExperts: 'Chemical experts around you',
    advisoryService: 'Provide excellent consulting services throughout the day',
    productCatalog: 'Product Catalog',
    teamPresentation: 'Team presentation',
    companyCertificate: 'Company Certificate',
    recentProjects: 'Our Recent Projects',
    productClassification: 'Product Classification',
    makeUp: 'Component',
    seeMore: 'See more',
    navigationBar: 'Navigation bar',
    subcategory: 'Subcategory',
    keyword: 'Keyword',
    productConsulting: 'Product consulting',
    productDescription: 'Product description',
    applicationAndPerformance: 'Application and performance',
    applicationField: 'Application field'
  },

  // 公司简介
  company: {
    companyProfile: "CompanyProfile",
    excellentQuality: "Excellent Quality",
    excellentQualitySub: "High quality, advanced, and professional",
    excellentQualityContent: "Based on demand, we support customized products and ensure the best quality.",
    supportOEM: "Support OEM and ODM customization",
    supportOEMSub: "Wide application, production experience, multi-channel, professional team, support for customization",
    supportOEMCosntent: "Not only products, but also corresponding solutions!Focusing on specialty chemicals!",
    since2010: "Since 2010",
    since2010Sub: "Years of production experience",
    since2010Content: "The company was established in 2010 and is a specialized chemical company that integrates research and development, production, sales, and service. In 2020, it was rated as a national high-tech enterprise.",
    tailorMade: "Tailor-made",
    tailorMadeSub: "Welcome to customize special products",
    tailorMadeContent: "More importantly, we are able to provide high-quality customized professional products in addition to conventional ones.",
  },

  //联系我们
  contactUs: {
    company: "Company",
    name: "Name",
    email: "Email",
    tel: "Phone Number",
    content: "Content",
    inputCompany: "Please enter the company name",
    inputName: "Please enter your Name",
    inputEmail: "Please enter your email address",
    inputTel: "Please enter your phone number",
    inputContent: "Please enter content",
    submit: "Sumbit",
    address: "Room 517, Building 29, No. 9 Weidi Road, Xianlin Street, Qixia District, Nanjing City",
    address1: "Address: Room 517, Building 29, No. 9 Weidi Road, Xianlin Street, Qixia District, Nanjing"
  }
}



// WEBPACK FOOTER //
// ./src/utils/language/en.js